import * as React from 'react'
import { PropsWithChildren } from 'react'
import LogoHeader from '../Header/Header.component'
import SveaFooter from '../Footer/Footer.component'
import Invoice from '../../../common/types/Invoice'
import { InvoiceLayoutWrapper, InvoiceMain } from './InvoiceLayout.style'
import InvoiceTitle from '../InvoiceTitle/InvoiceTitle.component'
import { TitleMode } from '../../../common/const'

interface InvoiceLayoutProps {
  templateConfigurationName?: string
  invoice?: Invoice
  fullScreenPopup?: boolean
  title?: string
  titleMode?: TitleMode.DEFAULT | TitleMode.SWAPPED | TitleMode.NO_ORIGINAL_MERCHANT
}

const InvoiceLayout = ({
  templateConfigurationName,
  invoice,
  children,
  fullScreenPopup,
  title,
  titleMode
}: PropsWithChildren<InvoiceLayoutProps>) => {
  const titleFromInvoice = invoice?.customData.carBrand || invoice?.invoiceDetails.originalMerchant

  return (
    <InvoiceLayoutWrapper fullScreenPopup={fullScreenPopup}>
      <LogoHeader />
      {invoice && (
        <InvoiceTitle
          templateConfigurationName={templateConfigurationName}
          fullScreenPopup={fullScreenPopup}
          merchantInvoiceTitle={titleFromInvoice}
          merchantInvoiceType={title}
          titleMode={titleMode}
        />
      )}
      <InvoiceMain fullScreenPopup={fullScreenPopup}>{children}</InvoiceMain>
      {!fullScreenPopup && <SveaFooter invoiceId={invoice?.invoiceId} />}
    </InvoiceLayoutWrapper>
  )
}

export default InvoiceLayout
